import { useEffect, useRef } from "react";
import { gameState } from "./gameStore";
import { POIS, CORRIDOR_BOUNDS } from "./poi";

const SIZE = 140;

function worldToMap(x, z) {
  const nx = (x - CORRIDOR_BOUNDS.minX) / (CORRIDOR_BOUNDS.maxX - CORRIDOR_BOUNDS.minX);
  const nz = (z - CORRIDOR_BOUNDS.minZ) / (CORRIDOR_BOUNDS.maxZ - CORRIDOR_BOUNDS.minZ);
  return { x: nx * SIZE, y: (1 - nz) * SIZE };
}

// Top-down radar so it's near-impossible to feel lost while walking the city.
export default function MiniMap({ visitedIds }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    let raf;
    const draw = () => {
      const canvas = canvasRef.current;
      const ctx = canvas?.getContext("2d");
      if (ctx) {
        ctx.clearRect(0, 0, SIZE, SIZE);
        ctx.fillStyle = "rgba(5,5,8,0.55)";
        ctx.fillRect(0, 0, SIZE, SIZE);

        POIS.forEach((poi) => {
          const [px, , pz] = poi.position;
          const { x, y } = worldToMap(px, pz);
          ctx.beginPath();
          ctx.arc(x, y, 4, 0, Math.PI * 2);
          ctx.fillStyle = visitedIds.current.has(poi.id) ? "#01FFFF" : "rgba(1,255,255,0.35)";
          ctx.fill();
        });

        const { x, y } = worldToMap(gameState.position.x, gameState.position.z);
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(gameState.facing);
        ctx.beginPath();
        ctx.moveTo(0, -6);
        ctx.lineTo(4, 5);
        ctx.lineTo(-4, 5);
        ctx.closePath();
        ctx.fillStyle = "#FF007F";
        ctx.fill();
        ctx.restore();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [visitedIds]);

  return (
    <div
      data-testid="game-minimap"
      className="pointer-events-none fixed top-24 right-6 z-40 border border-[#01FFFF]/30 bg-black/40 p-1 backdrop-blur-md"
    >
      <canvas ref={canvasRef} width={SIZE} height={SIZE} />
      <p className="mt-1 text-center font-mono text-[9px] tracking-widest text-[#8A9AAB]">MAP</p>
    </div>
  );
}
